import i18nFactory from '@yandex-int/i18n';

import { EditPageBackToFrontErrorMapper } from '../../../service/EditPageBackToFrontErrorMapper/EditPageBackToFrontErrorMapper';
import { createErrorsMapper, ErrorsMatcher } from '../../../service/ErrorsMapper/ErrorsMapper';
import { ValidationResultItem } from '../../../typings/common';

import * as keyset from './ExperimentsEditorErrorMapper.i18n';

const INDEX = '__INDEX__';
const i18n = i18nFactory(keyset);

export const createExperimentsConditionsErrorMapper = (campaignsIds: Array<string>): EditPageBackToFrontErrorMapper =>
    new EditPageBackToFrontErrorMapper(
        'campaigns',
        {
            items: [
                {
                    serverPath: ['sectionIds', INDEX],
                    clientPath: ['sectionIds', INDEX]
                }
            ]
        },
        campaignsIds,
        findOrReplaceExperimentRetargetingConditionErrorMapper,
        INDEX
    );

export const findOrReplaceExperimentRetargetingConditionErrorMapper = createErrorsMapper<{}>(
    ({ idx }): Array<ErrorsMatcher<{}>> => [
        {
            path: ['items', idx, 'sectionIds', idx],
            codes: [
                {
                    code: 'CollectionDefectIds.Gen.MUST_BE_IN_COLLECTION',
                    message: (err: ValidationResultItem): string => {
                        return i18n('default-error', { codeError: err.code });
                    }
                }
            ]
        }
    ],
    error => i18n('default-error', { codeError: error.code })
);
